export const GET_CUSTOM_FIELDS_EMPLOYEES = 'GET_CUSTOM_FIELDS_EMPLOYEES';
export const SET_CUSTOM_FIELDS_EMPLOYEES_PAGINATION = 'SET_CUSTOM_FIELDS_EMPLOYEES_PAGINATION';
export const SET_CUSTOM_FIELDS_EMPLOYEES_FILTERS = 'SET_CUSTOM_FIELDS_EMPLOYEES_FILTERS';
export const RESET_CUSTOM_FIELDS_EMPLOYEES = 'RESET_CUSTOM_FIELDS_EMPLOYEES';
export const TOGGLE_CUSTOM_FIELDS_EMPLOYEE = 'TOGGLE_CUSTOM_FIELDS_EMPLOYEE';
export const ADD_CUSTOM_FIELDS_EMPLOYEE = 'ADD_CUSTOM_FIELDS_EMPLOYEE';
export const UPDATE_CUSTOM_FIELDS_EMPLOYEE = 'UPDATE_CUSTOM_FIELDS_EMPLOYEE';
export const GET_CUSTOM_FIELDS_EMPLOYEE_BY_ID = 'GET_CUSTOM_FIELDS_EMPLOYEE_BY_ID';
export const RESET_CUSTOM_FIELDS_EMPLOYEE_FORM = 'RESET_CUSTOM_FIELDS_EMPLOYEE_FORM';
export const MODIFY_EDITING_CUSTOM_FIELDS_EMPLOYEE = 'MODIFY_EDITING_CUSTOM_FIELDS_EMPLOYEE';
export const ADD_CUSTOM_FIELD_CUSTOM_FIELDS_EMPLOYEE = 'ADD_CUSTOM_FIELD_CUSTOM_FIELDS_EMPLOYEE';
export const REMOVE_CUSTOM_FIELD_CUSTOM_FIELDS_EMPLOYEE =
  'REMOVE_CUSTOM_FIELD_CUSTOM_FIELDS_EMPLOYEE';



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/constants/employees_constants.js